import spriteMetadata from './spriteMetadata.json';
import { imageSrcByMaterial } from 'boardCanvas/Materials';
import { Material } from 'Types';

const THUMB_SIZE = 32;
const PATH = '/img/materials/sprite.jpg';

function invertObject(obj: {}) {
  var retobj = {};
  for (const key in obj) {
    // @ts-ignore
    retobj[obj[key]] = key;
  }
  return retobj;
}

const materialByImageSrc: { [key: string]: Material } =
  invertObject(imageSrcByMaterial);

// @ts-ignore
const spriteMetadataByMaterial: Record<Material, { x: number; y: number }> = {};

for (const key in spriteMetadata.coordinates) {
  const imageSrc =
    '/' +
    key
      .replace(/^public\//, '')
      .replace('/face-grain-thumb-jpg/', '/face-grain-jpg/');
  const material = materialByImageSrc[imageSrc];
  // @ts-ignore
  spriteMetadataByMaterial[material] = spriteMetadata.coordinates[key];
}

const { height: spriteHeight, width: spriteWidth } = spriteMetadata.properties;

function MaterialThumb(props: { material: Material; size?: number }) {
  const { material, size = 20 } = props;
  const ratio = size / THUMB_SIZE;
  const { x, y } = spriteMetadataByMaterial[material];
  return (
    <div
      style={{
        height: `${size}px`,
        width: `${size}px`,
        backgroundImage: `url(${PATH})`,
        backgroundPosition: `${-x * ratio}px ${-y * ratio}px`,
        backgroundSize: `${spriteWidth * ratio}px ${spriteHeight * ratio}px`,
      }}
    ></div>
  );
}

export default MaterialThumb;
